import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Dashboard } from './components/Dashboard';
import { KnowledgeSpaceDetail } from './components/knowledge-space/KnowledgeSpaceDetail';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { Toast } from './components/common/Toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ClientProvider } from './contexts/ClientContext';
import { AuthPage } from './components/auth/AuthPage';
import { AdminLayout } from './layouts/AdminLayout';
import { ClientLayout } from './layouts/ClientLayout';
import { ClientList } from './components/admin/ClientList';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { ChatbotSettingsModal } from './components/knowledge-space/chatbots/ChatbotSettingsModal';
// Wrap the modal component to provide navigation context
const ChatbotModalWrapper = () => {
  const navigate = useNavigate();
  return <ChatbotSettingsModal isOpen={true} onClose={() => navigate('../')} chatbot={{
    id: '',
    name: '',
    personality: '',
    status: 'active'
  }} onUpdate={() => {}} data-id="element-14" />;
};
// Default route handler
const DefaultRoute = () => {
  const {
    user
  } = useAuth();
  if (!user) {
    return <Navigate to="/login" replace data-id="element-15" />;
  }
  if (user.role.type === 'super_admin') {
    return <Navigate to="/admin/clients" replace data-id="element-16" />;
  }
  return <Navigate to="/dashboard" replace data-id="element-17" />;
};
export function App() {
  return <BrowserRouter data-id="element-18">
      <ErrorBoundary data-id="element-19">
        <AuthProvider data-id="element-20">
          <ClientProvider data-id="element-21">
            <div className="relative bg-surface min-h-screen w-full text-gray-100 font-sans" data-id="element-22">
              <div className="z-0 relative" data-id="element-23">
                <Routes data-id="element-24">
                  {/* Default Route */}
                  <Route path="/" element={<DefaultRoute data-id="element-26" />} data-id="element-25" />
                  {/* Auth Routes */}
                  <Route path="/login" element={<AuthPage data-id="element-28" />} data-id="element-27" />
                  {/* Admin Routes */}
                  <Route path="/admin" element={<ProtectedRoute requiredRole="super_admin" data-id="element-30">
                        <AdminLayout data-id="element-31" />
                      </ProtectedRoute>} data-id="element-29">
                    <Route index element={<Navigate to="clients" replace data-id="element-33" />} data-id="element-32" />
                    <Route path="clients" element={<ClientList data-id="element-35" />} data-id="element-34" />
                    <Route path="clients/:clientId" element={<div data-id="element-37">Client Details (Coming Soon)</div>} data-id="element-36" />
                  </Route>
                  {/* Client Routes */}
                  <Route path="/" element={<ProtectedRoute data-id="element-39">
                        <ClientLayout data-id="element-40" />
                      </ProtectedRoute>} data-id="element-38">
                    <Route path="dashboard" element={<Dashboard data-id="element-42" />} data-id="element-41" />
                    <Route path="space/:id" element={<KnowledgeSpaceDetail data-id="element-44" />} data-id="element-43">
                      <Route path="chatbot/:chatbotId" element={<ChatbotModalWrapper data-id="element-46" />} data-id="element-45" />
                    </Route>
                  </Route>
                </Routes>
              </div>
              <Toast data-id="element-47" />
            </div>
          </ClientProvider>
        </AuthProvider>
      </ErrorBoundary>
    </BrowserRouter>;
}